import "./Form.css";
import axios from "axios";
let inputText = "";
const host = "https://assistresearchlab.fit.edu";
function Form(props){

    const readFile = (event) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            inputText = data;
        };
        reader.readAsText(event.target.files[0]);

    }
    const sendRequest = () => {
        let options = {
            "input-text": inputText,
        };
        axios.get(`${host}/api`,  { params: { 'input-text': inputText }})
            .then(res => {
                props.setOutputText(res['data']);
            })
    };

    return (
        <div className="form-container">
            <h3>Upload Input Soar File</h3>
            <input type="file" onChange={(e) => {props.callback(true); readFile(e);}}/>
            { props.displayButton ? (
                <button className="submit" onClick={()=>{sendRequest();}}>Submit</button>
            ) : ""}
        </div>
    );
}

export default Form;
